import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { RegisterCredentials } from '../../../common/models/register-credentials';
import { AuthService } from '../../../common/shared/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import * as zxcvbn from 'zxcvbn';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { PrimaryContactLanguageEnum } from '../../../common/helper/enums';
import { CountryService } from '../../../common/shared/services/country.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  countries = this.countryService.countryList;
  registerCredentials = new RegisterCredentials();
  hidePW = true;
  consent = false;
  swedishPersonnummer = false;

  passwordStrength = 0;
  passwordRegEx = '';
  reCaptchaKey = '';
  reCaptchaValid = false;
  requirement = false;

  PrimaryContactLanguageEnum: typeof PrimaryContactLanguageEnum = PrimaryContactLanguageEnum;

  constructor(private _authService: AuthService,
              private _utilitiesService: UtilitiesService,
              private _activatedRoute: ActivatedRoute,
              private _translateService: TranslateService,
              private countryService: CountryService) {
                this.passwordRegEx = _utilitiesService.passwordRegEx;
  }

  ngOnInit() {
    this._authService.checkUserLoggedIn();

    this.reCaptchaKey = environment.reCaptchaKey;
    if (!this.reCaptchaKey || this.reCaptchaKey === '') {
      this.reCaptchaValid = true;
    }

    this._activatedRoute.queryParams.subscribe(params => {
      this._utilitiesService.setPreChoosenOrganisation(params['orgId']);
    });

    this._utilitiesService.removeInitAction(0);
  }

  register() {
    this.registerCredentials.personnummer = this.registerCredentials.personnummer.trim();
    this._utilitiesService.addMinorAction('Register');
    this._authService.register(this.registerCredentials);
  }

  registerActive() {
    return this._utilitiesService.isActionActive('Register');
  }

  personnummerValuechange(newValue) {
    if (newValue !== '' && newValue !== null && newValue !== undefined) {
      this._utilitiesService.checkPersonnumber(newValue).subscribe(
        data => {
          if (data) {
            this.swedishPersonnummer = this._utilitiesService.getData(data);
          }
        },
        err => {
          this._utilitiesService.handleErrors(err);
        }
      );
    }
  }

  updatePasswordStrength(): void {
    const results = zxcvbn(this.registerCredentials.password);
    this.passwordStrength = results.score;
  }

  handleCorrectCaptcha(event) {
    this.reCaptchaValid = true;
  }

  handleExpiredCaptcha() {
    this.reCaptchaValid = false;
  }

  getreCaptchaLanguage() {
    if (this._translateService.currentLang === 'se') {
      return 'sv';
    }
    return 'en';
  }
}
